import React  from 'react'
import moment from 'moment'
import 'datatables'
import 'datatables/media/css/jquery.dataTables.css'
export default class DataTable extends React.Component {
  render() {
    const {data} = this.props;
    var supportedStatusCode = [200, 202, 400, 401, 403, 404, 415, 429, 500, 501, "502 (computed)", 504, "duration", "all"]
    var now = data.dateEnd.clone()
    var dates = [now.clone()]
    var iterator = [0]
    for(var i = 1; i < 7; i ++) {
      iterator.push(i)
      dates.push(now.subtract(1, "days").clone())
    }

    var numberWithCommas = (x) => {
      x = x.toString();
      var pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(x))
        x = x.replace(pattern, "$1,$2");
      return x;
    }

    var reducer = (a, b) => a + parseInt(b.nRequests, 10)

    var totals = {}
    iterator.forEach(i => {
      var totalsCode = 0
      var d = dates[i].format("YYYY-MM-DD")
      if(!totals[d]) {
        totals[d] = {}
      }
      supportedStatusCode.forEach(code => {
        if(data.developerUsage && data.developerUsage[code]) {
          var n = data.developerUsage[code].filter(s=> s.time.startsWith(d)).reduce(reducer, 0)

          totals[d][code] = n
          if(code !== "all" && code !== "duration") {
            totalsCode += n
          }
        }
      })
      if(totals[d] && totals[d]["all"]) {
        totals[d]["502 (computed)"] = totals[d]["all"] - totalsCode
      } else {
        totals[d]["502 (computed)"] = 0
      }
    })

    return (
      <table 
          className = "tbl developerUsageTable">
          <thead>
            <tr className = "titre">
              <th>Code</th>
              {dates.reverse().map(d => {
                return <th key = {"developerUsageTable" + d + data.did}>{d.format('DD-MM-YY')}</th>
              })}
            </tr>
          </thead>
          <tbody>
            {supportedStatusCode.map(code => {
              return(
                <tr key = {"developerUsageTable" + code + data.did}>
                  <td>{code}</td>
                  {iterator.map(i => {
                    var n = totals[dates[i].format("YYYY-MM-DD")][code]
                    if(n) {
                      if(code === "duration") {
                        var momentInSeconds = moment.duration(n,'seconds')
                        return(<td key={"td" + data.did + i}>
                          {(parseInt(Math.floor(momentInSeconds.asHours()))) + ':' + ("0" + momentInSeconds.minutes()).slice(-2) + ':' + ("0" + momentInSeconds.seconds()).slice(-2)}
                        </td>)
                      } else {
                        if(code === "502 (computed)") {
                        }
                        return (<td key={"td" + data.did + i}>
                          {numberWithCommas(n | 0)}
                        </td>)
                      }

                    } else {
                      var s = 0
                      if(code === "duration"){
                        s = "00:00:00"
                      }
                      return(<td key={"td" + data.did + i}>{s}</td>)
                    }
                  })}
                </tr>
              )
            })}
            {
              <tr key = {"developerTotalUsage" + data.did}>
                <td>Total w/o 429</td>
                {iterator.map(i => {
                  var totalUsage = data.totalUsage[dates[i].format("YYYY-MM-DD")]
                    if(totalUsage) {
                      return (<td key={"totalUsagetd" + data.did + i}>
                        {numberWithCommas(totalUsage - (data.developerUsage && data.developerUsage["429"] ? data.developerUsage["429"].filter(s=> s.time.startsWith(dates[i].format("YYYY-MM-DD"))).reduce(reducer, 0) : 0))}
                      </td>)
                    } else {
                      return(<td key={"totalUsagetd" + data.did + i}>0</td>)
                    }
                  })}
              </tr>
            }
          </tbody>
        </table>
    );
  }
}


// WEBPACK FOOTER //
// ./src/DeveloperUsageTable.js